module.exports = __webpack_public_path__ + "static/media/simon-bolivar-john-lynch.92becba2.jpg";